/** Perfiles existentes en KeyStoreMan. NO existe 'admin'. */
export type Profile = 'sudo' | 'user';

export interface IProfile {
  profile: Profile;
  description: string;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: string;
  updatedAt: string;
}

export class ProfileModel {
  profile: Profile;
  description: string;
  status: boolean;
  uidCreatedBy: string | null;
  uidUpdatedBy: string | null;
  createdAt: Date;
  updatedAt: Date;

  constructor(data: IProfile) {
    this.profile = data.profile;
    this.description = data.description;
    this.status = data.status;
    this.uidCreatedBy = data.uidCreatedBy ?? null;
    this.uidUpdatedBy = data.uidUpdatedBy ?? null;
    this.createdAt = new Date(data.createdAt);
    this.updatedAt = new Date(data.updatedAt);
  }
}
